import React from 'react';
import { FacebookIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t-4 border-[#E41C1C] py-12" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12" data-id="element-46">
          <a href="https://www.trashbilling.com/" target="_blank" rel="noopener noreferrer" className="bg-[#E41C1C] text-white font-bold px-6 py-3 rounded hover:bg-red-700 transition-colors text-center" data-id="element-47">
            Pay Bill
          </a>
          <a href="#reed-city-registration" className="bg-[#002868] text-white font-bold px-6 py-3 rounded hover:bg-[#001f4d] transition-colors text-center" data-id="element-48">
            Reed City Customer Registration
          </a>
        </div>
        {/* Top Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-8" data-id="element-49">
          {/* Logo and Tagline */}
          <div className="flex flex-col items-center md:items-start" data-id="element-50">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rYyHQnqA6sgXSrChTLK2Yb/Sams-Disposal-logo.png" alt="Sam's Disposal" className="h-16 w-auto mb-3" data-id="element-51" />
            <p className="text-sm font-bold text-gray-700" data-id="element-52">
              Local. Reliable. Family Owned.
            </p>
          </div>
          {/* Contact Info */}
          <div className="text-center" data-id="element-53">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-54">Contact Us</h3>
            <a href="tel:231-796-2952" className="text-[#E41C1C] font-bold text-xl hover:text-red-700 transition-colors" data-id="element-55">
              (231) 796-2952
            </a>
          </div>
          {/* Social Media */}
          <div className="text-center md:text-right" data-id="element-56">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-57">Follow Us</h3>
            <a href="https://www.facebook.com/SamsDisposal/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-12 h-12 bg-[#E41C1C] rounded-full hover:bg-red-700 transition-colors" data-id="element-58">
              <FacebookIcon className="w-6 h-6 text-white" data-id="element-59" />
            </a>
          </div>
        </div>
        {/* Navigation Links */}
        <div className="border-t border-gray-200 pt-8 mb-8" data-id="element-60">
          <nav className="flex flex-wrap justify-center gap-8" data-id="element-61">
            <a href="#home" className="text-gray-700 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-62">
              Home
            </a>
            <a href="#services" className="text-gray-700 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-63">
              Services
            </a>
            <a href="#about" className="text-gray-700 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-64">
              About
            </a>
            <a href="#contact" className="text-gray-700 font-bold hover:text-[#E41C1C] transition-colors" data-id="element-65">
              Contact
            </a>
          </nav>
        </div>
        {/* Copyright */}
        <div className="text-center text-gray-600 text-sm" data-id="element-66">
          <p data-id="element-67">
            © {new Date().getFullYear()} Sam's Disposal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}